module.exports = __webpack_public_path__ + "img/FJ.c98533e6.svg";